// SWR全局配置
import { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  // 全局配置
  revalidateOnFocus: false, // 窗口聚焦时不重新验证
  revalidateOnReconnect: true, // 网络重连时重新验证
  revalidateIfStale: true, // 数据过期时重新验证
  revalidateOnMount: true, // 组件挂载时重新验证
  
  // 错误重试配置
  errorRetryCount: 3, // 最多重试3次
  errorRetryInterval: 5000, // 重试间隔5秒
  
  // 数据去重配置
  dedupingInterval: 2000, // 2秒内相同请求去重
  
  // 全局错误处理
  onError: (error, key) => {
    console.error('SWR Error:', error, 'Key:', key);
    // 可以在这里添加全局错误处理逻辑，比如发送到错误监控服务
  },
  
  // 全局成功处理
  onSuccess: (data, key) => {
    console.log('SWR Success:', key, data);
  },
  
  // 比较函数，用于判断数据是否发生变化
  compare: (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  },
  
  // 是否应该重新验证
  shouldRetryOnError: (error) => {
    // 对于某些错误不重试
    if (error?.status === 404 || error?.status === 403) {
      return false;
    }
    return true;
  },
  
  // 加载超时
  loadingTimeout: 10000, // 10秒超时
  
  // 刷新间隔（毫秒）
  refreshInterval: 0, // 默认不自动刷新，由各个hook自行配置
  
  // 当窗口不可见时暂停刷新
  refreshWhenHidden: false,
  
  // 当窗口重新可见时刷新
  refreshWhenOffline: false,
};

// 特定场景的配置
export const productSWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 60000, // 商品数据1分钟内去重
  refreshInterval: 0, // 商品数据不自动刷新
};

export const orderSWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 30000, // 订单数据30秒内去重
  refreshInterval: 0, // 订单数据不自动刷新
};

export const deliverySWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 10000, // 配送数据10秒内去重
  refreshInterval: 30000, // 配送数据30秒自动刷新
};

export const messageSWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 1000, // 消息数据1秒内去重
  refreshInterval: 5000, // 消息数据5秒自动刷新
};

export const paymentSWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 5000, // 支付数据5秒内去重
  refreshInterval: 10000, // 支付数据10秒自动刷新
};

export const deleteAccountSWRConfig: SWRConfiguration = {
  ...swrConfig,
  dedupingInterval: 0, // 销户操作不缓存
  refreshInterval: 0, // 销户操作不自动刷新
  revalidateOnFocus: false, // 销户操作不重新验证
  revalidateOnReconnect: false, // 销户操作不重新连接验证
};
